var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsFileEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6368",
    "data-name": "Rectangle 6368",
    width: 206,
    height: 206,
    transform: "translate(1086 293)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_15639",
    x: 26.626,
    y: 19.7,
    width: 130.747,
    height: 151.018,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_15639-2",
    x: 51,
    y: 35.875,
    width: 104,
    height: 132.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_701",
    x: 109,
    y: 125,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#44580a",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(-1086 -293)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18889",
    "data-name": "Group 18889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18425",
    "data-name": "Group 18425",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -71.997, 314.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18420",
    "data-name": "Group 18420",
    transform: "translate(2 -42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, 0.26, -0.26, 0.97, 1122, 321.33)",
    filter: "url(#Path_15639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15639-3",
    "data-name": "Path 15639",
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 57.14, 128.25)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80.63851165771484 31.04178810119629 L 80.62493896484375 31.04178810119629 L 5.348092555999756 31.04178810119629 C 2.675415754318237 31.03506469726562 0.5000002384185791 28.85423469543457 0.5000002384185791 26.18035697937012 L 0.5000002384185791 26.16678810119629 L 0.5000002384185791 -77.77670288085938 C 0.5067233443260193 -80.44937896728516 2.687554121017456 -82.62479400634766 5.361431121826172 -82.62479400634766 L 5.375000476837158 -82.62479400634766 L 56.83329391479492 -82.62479400634766 L 56.83329391479492 -58.04147338867188 C 56.83329391479492 -55.78992080688477 58.66507720947266 -53.95814895629883 60.91662979125977 -53.95814895629883 L 85.49993896484375 -53.95814895629883 L 85.49993896484375 26.19369697570801 C 85.49321746826172 28.86637306213379 83.31238555908203 31.04178810119629 80.63851165771484 31.04178810119629 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.361427307128906 -82.12479400634766 C 2.962570190429688 -82.12479400634766 1.006027221679688 -80.17311859130859 1 -77.77670288085938 L 1 26.18034362792969 C 1 28.57920074462891 2.951675415039062 30.53574371337891 5.348091125488281 30.54178619384766 L 80.63850402832031 30.54178619384766 C 83.037353515625 30.54178619384766 84.99388885498047 28.59011077880859 84.99993896484375 26.19369506835938 L 84.99993896484375 -53.45814895629883 L 60.91663360595703 -53.45814895629883 C 58.38936996459961 -53.45814895629883 56.33329010009766 -55.51422882080078 56.33329010009766 -58.04148864746094 L 56.33329010009766 -82.12479400634766 L 5.361427307128906 -82.12479400634766 M 5.361427307128906 -83.12479400634766 L 57.33329010009766 -83.12479400634766 L 57.33329010009766 -58.04148864746094 C 57.33329010009766 -56.06347274780273 58.93861389160156 -54.45814895629883 60.91663360595703 -54.45814895629883 L 85.99993896484375 -54.45814895629883 L 85.99993896484375 26.19369506835938 C 85.99249267578125 29.14582061767578 83.59062957763672 31.54178619384766 80.63850402832031 31.54178619384766 L 5.348091125488281 31.54178619384766 C 2.395950317382812 31.53433990478516 0 29.13249969482422 0 26.18034362792969 L 0 -77.77670288085938 C 0.0074310302734375 -80.72884368896484 2.409294128417969 -83.12479400634766 5.361427307128906 -83.12479400634766 Z",
    stroke: "none",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18423",
    "data-name": "Group 18423",
    transform: "translate(3 35)",
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6281",
    "data-name": "Rectangle 6281",
    width: 15,
    height: 30,
    transform: "translate(1162 394)",
    fill: "#f0f0f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6277",
    "data-name": "Rectangle 6277",
    transform: "translate(1161 392)",
    fill: "none",
    stroke: "#dadadc",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 33,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 45,
    height: 31,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6278",
    "data-name": "Rectangle 6278",
    width: 46,
    height: 2,
    transform: "translate(1162 402)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6279",
    "data-name": "Rectangle 6279",
    width: 46,
    height: 2,
    transform: "translate(1162 413)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6280",
    "data-name": "Rectangle 6280",
    width: 2,
    height: 33,
    transform: "translate(1175 392)",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_15640",
    "data-name": "Path 15640",
    transform: "translate(1155.833 418)",
    fill: "#dadadc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.66653442382812 -54.95815277099609 L 51.08321762084961 -54.95815277099609 C 49.38306427001953 -54.95815277099609 47.99988555908203 -56.34133148193359 47.99988555908203 -58.04148483276367 L 47.99988555908203 -82.62479400634766 L 48.86594772338867 -82.62479400634766 L 48.87928771972656 -82.62479400634766 C 49.97123718261719 -82.62479400634766 51.54700469970703 -81.97367095947266 52.32025527954102 -81.20296478271484 L 74.24509429931641 -59.25581359863281 C 75.01567840576172 -58.48523330688477 75.66653442382812 -56.91393280029297 75.66653442382812 -55.82442474365234 L 75.66653442382812 -54.95815277099609 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.16653442382812 -55.45815277099609 L 75.16653442382812 -55.82442474365234 C 75.16653442382812 -56.78482437133789 74.57082366943359 -58.22297286987305 73.891357421875 -58.90243148803711 L 51.96728515625 -80.84882354736328 C 51.28532791137695 -81.52854156494141 49.84233474731445 -82.12479400634766 48.87928771972656 -82.12479400634766 L 48.49988555908203 -82.12479400634766 L 48.49988555908203 -58.04148483276367 C 48.49988555908203 -56.61703491210938 49.65876770019531 -55.45815277099609 51.08321762084961 -55.45815277099609 L 75.16653442382812 -55.45815277099609 M 76.16653442382812 -54.45815277099609 L 51.08321762084961 -54.45815277099609 C 49.10520553588867 -54.45815277099609 47.49988555908203 -56.0634651184082 47.49988555908203 -58.04148483276367 L 47.49988555908203 -83.12479400634766 L 48.87928771972656 -83.12479400634766 C 50.10514450073242 -83.12479400634766 51.80494689941406 -82.42252349853516 52.67322540283203 -81.55709075927734 L 74.59882354736328 -59.60918426513672 C 75.46425628662109 -58.7437629699707 76.16653442382812 -57.04810333251953 76.16653442382812 -55.82442474365234 L 76.16653442382812 -54.45815277099609 Z",
    stroke: "none",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18424",
    "data-name": "Group 18424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18420-2",
    "data-name": "Group 18420",
    transform: "translate(2 -42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1084, 335)",
    filter: "url(#Path_15639-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15639-4",
    "data-name": "Path 15639",
    transform: "translate(60 125)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80.63851165771484 31.04178810119629 L 80.62493896484375 31.04178810119629 L 5.348092555999756 31.04178810119629 C 2.675415754318237 31.03506469726562 0.5000002384185791 28.85423469543457 0.5000002384185791 26.18035697937012 L 0.5000002384185791 26.16678810119629 L 0.5000002384185791 -77.77670288085938 C 0.5067233443260193 -80.44937896728516 2.687554121017456 -82.62479400634766 5.361431121826172 -82.62479400634766 L 5.375000476837158 -82.62479400634766 L 56.83329391479492 -82.62479400634766 L 56.83329391479492 -58.04147338867188 C 56.83329391479492 -55.78992080688477 58.66507720947266 -53.95814895629883 60.91662979125977 -53.95814895629883 L 85.49993896484375 -53.95814895629883 L 85.49993896484375 26.19369697570801 C 85.49321746826172 28.86637306213379 83.31238555908203 31.04178810119629 80.63851165771484 31.04178810119629 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.361427307128906 -82.12479400634766 C 2.962570190429688 -82.12479400634766 1.006027221679688 -80.17311859130859 1 -77.77670288085938 L 1 26.18034362792969 C 1 28.57920074462891 2.951675415039062 30.53574371337891 5.348091125488281 30.54178619384766 L 80.63850402832031 30.54178619384766 C 83.037353515625 30.54178619384766 84.99388885498047 28.59011077880859 84.99993896484375 26.19369506835938 L 84.99993896484375 -53.45814895629883 L 60.91663360595703 -53.45814895629883 C 58.38936996459961 -53.45814895629883 56.33329010009766 -55.51422882080078 56.33329010009766 -58.04148864746094 L 56.33329010009766 -82.12479400634766 L 5.361427307128906 -82.12479400634766 M 5.361427307128906 -83.12479400634766 L 57.33329010009766 -83.12479400634766 L 57.33329010009766 -58.04148864746094 C 57.33329010009766 -56.06347274780273 58.93861389160156 -54.45814895629883 60.91663360595703 -54.45814895629883 L 85.99993896484375 -54.45814895629883 L 85.99993896484375 26.19369506835938 C 85.99249267578125 29.14582061767578 83.59062957763672 31.54178619384766 80.63850402832031 31.54178619384766 L 5.348091125488281 31.54178619384766 C 2.395950317382812 31.53433990478516 0 29.13249969482422 0 26.18034362792969 L 0 -77.77670288085938 C 0.0074310302734375 -80.72884368896484 2.409294128417969 -83.12479400634766 5.361427307128906 -83.12479400634766 Z",
    stroke: "none",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18423-2",
    "data-name": "Group 18423",
    transform: "translate(3 42)",
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6281-2",
    "data-name": "Rectangle 6281",
    width: 15,
    height: 31,
    transform: "translate(1162 393)",
    fill: "#f0f0f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6277-2",
    "data-name": "Rectangle 6277",
    transform: "translate(1161 381)",
    fill: "none",
    stroke: "#dadadc",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 44,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 45,
    height: 42,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6278-2",
    "data-name": "Rectangle 6278",
    width: 46,
    height: 2,
    transform: "translate(1162 402)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6282",
    "data-name": "Rectangle 6282",
    width: 46,
    height: 2,
    transform: "translate(1162 391)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6279-2",
    "data-name": "Rectangle 6279",
    width: 46,
    height: 2,
    transform: "translate(1162 413)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6280-2",
    "data-name": "Rectangle 6280",
    width: 2,
    height: 33,
    transform: "translate(1175 392)",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_15640-2",
    "data-name": "Path 15640",
    transform: "translate(1155.833 418)",
    fill: "#dadadc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.66653442382812 -54.95815277099609 L 51.08321762084961 -54.95815277099609 C 49.38306427001953 -54.95815277099609 47.99988555908203 -56.34133148193359 47.99988555908203 -58.04148483276367 L 47.99988555908203 -82.62479400634766 L 48.86594772338867 -82.62479400634766 L 48.87928771972656 -82.62479400634766 C 49.97123718261719 -82.62479400634766 51.54700469970703 -81.97367095947266 52.32025527954102 -81.20296478271484 L 74.24509429931641 -59.25581359863281 C 75.01567840576172 -58.48523330688477 75.66653442382812 -56.91393280029297 75.66653442382812 -55.82442474365234 L 75.66653442382812 -54.95815277099609 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.16653442382812 -55.45815277099609 L 75.16653442382812 -55.82442474365234 C 75.16653442382812 -56.78482437133789 74.57082366943359 -58.22297286987305 73.891357421875 -58.90243148803711 L 51.96728515625 -80.84882354736328 C 51.28532791137695 -81.52854156494141 49.84233474731445 -82.12479400634766 48.87928771972656 -82.12479400634766 L 48.49988555908203 -82.12479400634766 L 48.49988555908203 -58.04148483276367 C 48.49988555908203 -56.61703491210938 49.65876770019531 -55.45815277099609 51.08321762084961 -55.45815277099609 L 75.16653442382812 -55.45815277099609 M 76.16653442382812 -54.45815277099609 L 51.08321762084961 -54.45815277099609 C 49.10520553588867 -54.45815277099609 47.49988555908203 -56.0634651184082 47.49988555908203 -58.04148483276367 L 47.49988555908203 -83.12479400634766 L 48.87928771972656 -83.12479400634766 C 50.10514450073242 -83.12479400634766 51.80494689941406 -82.42252349853516 52.67322540283203 -81.55709075927734 L 74.59882354736328 -59.60918426513672 C 75.46425628662109 -58.7437629699707 76.16653442382812 -57.04810333251953 76.16653442382812 -55.82442474365234 L 76.16653442382812 -54.45815277099609 Z",
    stroke: "none",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18422",
    "data-name": "Group 18422",
    transform: "translate(10 12.122)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1076, 280.88)",
    filter: "url(#Ellipse_701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_701-2",
    "data-name": "Ellipse 701",
    transform: "translate(118 131)",
    fill: "#d90327",
    stroke: "rgba(0,0,0,0.06)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18892",
    "data-name": "Group 18892",
    transform: "translate(1205.51 416.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15561",
    "data-name": "Path 15561",
    d: "M235.947,173.005c-1.331,0-2.369.714-2.369,1.98,0,3.862.454,9.412.454,13.275,0,1.006.876,1.428,1.915,1.428.779,0,1.882-.422,1.882-1.428,0-3.862.454-9.412.454-13.275A2.086,2.086,0,0,0,235.947,173.005Z",
    transform: "translate(-225.975 -168.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17622",
    "data-name": "Group 17622",
    transform: "translate(7.506 23.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17621",
    "data-name": "Group 17621",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15562",
    "data-name": "Path 15562",
    d: "M235.15,353.306a2.5,2.5,0,0,0,0,5,2.5,2.5,0,0,0,0-5Z",
    transform: "translate(-232.651 -353.306)",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsFileEmpty);
export default __webpack_public_path__ + "static/media/xls-file-empty.7fdbb7666d180ac82b513860f8a6c817.svg";
export { ForwardRef as ReactComponent };